import { render } from "./InputRadioGroup.vue?vue&type=template&id=aebd976a&scoped=true"
import script from "./InputRadioGroup.vue?vue&type=script&lang=js"
export * from "./InputRadioGroup.vue?vue&type=script&lang=js"

import "./InputRadioGroup.vue?vue&type=style&index=0&id=aebd976a&scoped=true&lang=css"

import exportComponent from "/builds/pazzei/pazzei-landing/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-aebd976a"]])

export default __exports__